import {SvgIcon, SxProps} from "@mui/material";
import SendSvg from "jsx:../../../../../Images/Icons/FontAwesome/solid/paper-plane-top.svg";
import React from "react";

export function SendIcon(props: SxProps) {
    return <SvgIcon component={SendSvg as any} inheritViewBox sx={props} />;
}
